// project import
import getColors from 'utils/getColors'

// ==============================|| ALERT - COLORS ||============================== //

function getColorStyle({ color, theme }) {
  const colors = getColors(theme, color)
  const { main } = colors

  return {
    borderColor: main,
    '& .MuiAlert-icon': {
      color: main,
    },
  }
}

// ==============================|| OVERRIDES - ALERT ||============================== //

export default function Alert(theme) {
  const primaryDashed = getColorStyle({ color: 'primary', theme })

  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.main,
          '&.MuiPaper-root': {
            padding: '0.75rem',
            alignItems: 'flex-start',
          },
        },
        icon: {
          fontSize: '0.875rem',
          padding: 0,
          marginTop: '6px',
          marginRight: '0.5rem',
        },
        message: {
          padding: 0,
          color: theme.palette.text.primary,
        },
        filled: {
          color: theme.palette.grey[0],
          border: '1px solid',
          '&.MuiAlert-filledPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiAlert-filledSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiAlert-filledError': getColorStyle({ color: 'error', theme }),
          '&.MuiAlert-filledSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiAlert-filledInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiAlert-filledWarning': getColorStyle({ color: 'warning', theme }),
        },
        outlined: {
          border: '1px solid',
          ...primaryDashed,
          '&.MuiAlert-outlinedPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiAlert-outlinedSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiAlert-outlinedError': getColorStyle({ color: 'error', theme }),
          '&.MuiAlert-outlinedSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiAlert-outlinedInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiAlert-outlinedWarning': getColorStyle({ color: 'warning', theme }),
        },
        border: {
          border: '1px solid',
          ...primaryDashed,
          '&.MuiAlert-borderPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiAlert-borderSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiAlert-borderError': getColorStyle({ color: 'error', theme }),
          '&.MuiAlert-borderSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiAlert-borderInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiAlert-borderWarning': getColorStyle({ color: 'warning', theme }),
        },
        action: {
          color: theme.palette.text.primary,
          '& .MuiButton-root': {
            padding: 2,
            height: 'auto',
            fontSize: '0.75rem',
            marginTop: -2,
          },
          '& .MuiIconButton-root': {
            width: 'auto',
            height: 'auto',
            padding: 2,
            marginRight: 6,
            '& .MuiSvgIcon-root': {
              fontSize: '0.875rem',
            },
          },
        },
      },
    },
  }
}
